module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "imtoken.148ecc42.svg";